import { Joyride } from "react-joyride";
import type { Options, PartialDeep, Styles } from "react-joyride";
import type { OnboardingTourProps } from "./types";

/** Default options applied to every tour step. */
const TOUR_OPTIONS: Partial<Options> = {
  skipBeacon: true,
  showProgress: true,
  overlayClickAction: false,
  dismissKeyAction: false,
  blockTargetInteraction: true,
  zIndex: 10000,
  primaryColor: "#2563eb",
  spotlightPadding: 8,
  buttons: ["back", "skip", "primary"],
};

/** Visual hierarchy for the tooltip: a bold, dark title over softer body text. */
const TOUR_STYLES: PartialDeep<Styles> = {
  tooltipTitle: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#111827",
  },
  tooltipContent: {
    fontSize: "14px",
    lineHeight: 1.6,
    color: "#4b5563",
  },
  buttonSkip: {
    color: "#dc2626",
  },
};

export const OnboardingTour = ({
  run,
  steps,
  locale,
  onEvent,
}: OnboardingTourProps) => {
  return (
    <Joyride
      run={run}
      continuous
      steps={steps}
      locale={locale}
      options={TOUR_OPTIONS}
      styles={TOUR_STYLES}
      onEvent={onEvent}
      scrollToFirstStep
    />
  );
};
